import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CiudadesModels } from '../../models/ciudades';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class CiudadesService {

  baseUri = environment.URL_MULESOFT_CIUDADES;
  // NOTA: TOKEN_MULESOFT eliminado - autenticación moderna via interceptors

  constructor(private http: HttpClient) { }

  public getCiudadesSura(): string {
    return JSON.stringify(
      JSON.parse(
        JSON.stringify(
          {
            "data": [
              {
                "value": "50006000",
                "label": "Acacias - Meta"
              },
              {
                "value": "76020000",
                "label": "Alcala - Valle Del Cauca"
              },
              {
                "value": "5030000",
                "label": "Amaga - Antioquia"
              },
              {
                "value": "5045000",
                "label": "Apartado - Antioquia"
              },
              {
                "value": "13052000",
                "label": "Arjona - Bolívar"
              },
              {
                "value": "63001000",
                "label": "Armenia - Quindío"
              },
              {
                "value": "8078000",
                "label": "Baranoa - Atlántico"
              },
              {
                "value": "5079000",
                "label": "Barbosa - Antioquia"
              },
              {
                "value": "8001000",
                "label": "Barranquilla - Atlántico"
              },
              {
                "value": "5088000",
                "label": "Bello - Antioquia"
              },
              {
                "value": "11001000",
                "label": "Bogotá D.C. - Bogotá D.C."
              },
              {
                "value": "25099000",
                "label": "Bojaca - Cundinamarca"
              },
              {
                "value": "11102000",
                "label": "Bosa - Bogotá D.C."
              },
              {
                "value": "68001000",
                "label": "Bucaramanga - Santander"
              },
              {
                "value": "76109000",
                "label": "Buenaventura - Valle Del Cauca"
              },
              {
                "value": "63111000",
                "label": "Buenavista - Quindío"
              },
              {
                "value": "76122000",
                "label": "Caicedonia - Valle Del Cauca"
              },
              {
                "value": "25126000",
                "label": "Cajica - Cundinamarca"
              },
              {
                "value": "63130000",
                "label": "Calarca - Quindío"
              },
              {
                "value": "5129000",
                "label": "Caldas - Antioquia"
              },
              {
                "value": "76001000",
                "label": "Cali - Valle Del Cauca"
              },
              {
                "value": "76130000",
                "label": "Candelaria - Valle Del Cauca"
              },
              {
                "value": "5147000",
                "label": "Carepa - Antioquia"
              },
              {
                "value": "13001000",
                "label": "Cartagena De Indias - Bolívar"
              },
              {
                "value": "76147000",
                "label": "Cartago - Valle Del Cauca"
              },
              {
                "value": "23162000",
                "label": "Cerete - Córdoba"
              },
              {
                "value": "25175000",
                "label": "Chia - Cundinamarca"
              },
              {
                "value": "5172000",
                "label": "Chigorodo - Antioquia"
              },
              {
                "value": "11850000",
                "label": "Chinauta - Cundinamarca"
              },
              {
                "value": "17174000",
                "label": "Chinchina - Caldas"
              },
              {
                "value": "63190000",
                "label": "Circasia - Quindío"
              },
              {
                "value": "13222000",
                "label": "Clemencia - Bolívar"
              },
              {
                "value": "15204000",
                "label": "Combita - Boyacá"
              },
              {
                "value": "5212000",
                "label": "Copacabana - Antioquia"
              },
              {
                "value": "63212000",
                "label": "Cordoba - Quindío"
              },
              {
                "value": "25214000",
                "label": "Cota - Cundinamarca"
              },
              {
                "value": "54001000",
                "label": "Cucuta - Norte De Santander"
              },
              {
                "value": "50226000",
                "label": "Cumaral - Meta"
              },
              {
                "value": "66170000",
                "label": "Dosquebradas - Risaralda"
              },
              {
                "value": "15238000",
                "label": "Duitama - Boyacá"
              },
              {
                "value": "5148000",
                "label": "El Carmen De Viboral - Antioquia"
              },
              {
                "value": "54261000",
                "label": "El Zulia - Norte De Santander"
              },
              {
                "value": "11265000",
                "label": "Engativa - Bogotá D.C."
              },
              {
                "value": "5266000",
                "label": "Envigado - Antioquia"
              },
              {
                "value": "73268000",
                "label": "Espinal - Tolima"
              },
              {
                "value": "25269000",
                "label": "Facatativa - Cundinamarca"
              },
              {
                "value": "63272000",
                "label": "Filandia - Quindío"
              },
              {
                "value": "18001000",
                "label": "Florencia - Caquetá"
              },
              {
                "value": "68276000",
                "label": "Floridablanca - Santander"
              },
              {
                "value": "11279000",
                "label": "Fontibon - Bogotá D.C."
              },
              {
                "value": "25286000",
                "label": "Funza - Cundinamarca"
              },
              {
                "value": "25290000",
                "label": "Fusagasuga - Cundinamarca"
              },
              {
                "value": "8296000",
                "label": "Galapa - Atlántico"
              },
              {
                "value": "63302000",
                "label": "Genova - Quindío"
              },
              {
                "value": "25307000",
                "label": "Girardot - Cundinamarca"
              },
              {
                "value": "5308000",
                "label": "Girardota - Antioquia"
              },
              {
                "value": "68307000",
                "label": "Giron - Santander"
              },
              {
                "value": "76111000",
                "label": "Guadalajara De Buga - Valle Del Cauca"
              },
              {
                "value": "50318000",
                "label": "Guamal - Meta"
              },
              {
                "value": "5318000",
                "label": "Guarne - Antioquia"
              },
              {
                "value": "25335000",
                "label": "Guayabetal - Cundinamarca"
              },
              {
                "value": "73001000",
                "label": "Ibague - Tolima"
              },
              {
                "value": "5360000",
                "label": "Itagüi - Antioquia"
              },
              {
                "value": "76364000",
                "label": "Jamundi - Valle Del Cauca"
              },
              {
                "value": "25377000",
                "label": "La Calera - Cundinamarca"
              },
              {
                "value": "5376000",
                "label": "La Ceja - Antioquia"
              },
              {
                "value": "5380000",
                "label": "La Estrella - Antioquia"
              },
              {
                "value": "50001000",
                "label": "La Palmera - Meta"
              },
              {
                "value": "63401000",
                "label": "La Tebaida - Quindío"
              },
              {
                "value": "66400000",
                "label": "La Virginia - Risaralda"
              },
              {
                "value": "68406000",
                "label": "Lebrija - Santander"
              },
              {
                "value": "54405000",
                "label": "Los Patios - Norte De Santander"
              },
              {
                "value": "25430000",
                "label": "Madrid - Cundinamarca"
              },
              {
                "value": "8433000",
                "label": "Malambo - Atlántico"
              },
              {
                "value": "17001000",
                "label": "Manizales - Caldas"
              },
              {
                "value": "5440000",
                "label": "Marinilla - Antioquia"
              },
              {
                "value": "66440000",
                "label": "Marsella - Risaralda"
              },
              {
                "value": "5001000",
                "label": "Medellin - Antioquia"
              },
              {
                "value": "73449000",
                "label": "Melgar - Tolima"
              },
              {
                "value": "63470000",
                "label": "Montenegro - Quindío"
              },
              {
                "value": "23001000",
                "label": "Monteria - Córdoba"
              },
              {
                "value": "25473000",
                "label": "Mosquera - Cundinamarca"
              },
              {
                "value": "15476000",
                "label": "Motavita - Boyacá"
              },
              {
                "value": "5490000",
                "label": "Necocli - Antioquia"
              },
              {
                "value": "17486000",
                "label": "Neira - Caldas"
              },
              {
                "value": "41001000",
                "label": "Neiva - Huila"
              },
              {
                "value": "15500000",
                "label": "Oicata - Boyacá"
              },
              {
                "value": "15516000",
                "label": "Paipa - Boyacá"
              },
              {
                "value": "17524000",
                "label": "Palestina - Caldas"
              },
              {
                "value": "76520000",
                "label": "Palmira - Valle Del Cauca"
              },
              {
                "value": "66001000",
                "label": "Pereira - Risaralda"
              },
              {
                "value": "68547000",
                "label": "Piedecuesta - Santander"
              },
              {
                "value": "63548000",
                "label": "Pijao - Quindío"
              },
              {
                "value": "50001001",
                "label": "Pipiral - Meta"
              },
              {
                "value": "19001000",
                "label": "Popayan - Cauca"
              },
              {
                "value": "8573000",
                "label": "Puerto Colombia - Atlántico"
              },
              {
                "value": "25594000",
                "label": "Quetame - Cundinamarca"
              },
              {
                "value": "63594000",
                "label": "Quimbaya - Quindío"
              },
              {
                "value": "50606000",
                "label": "Restrepo - Meta"
              },
              {
                "value": "5607000",
                "label": "Retiro - Antioquia"
              },
              {
                "value": "25612000",
                "label": "Ricaurte - Cundinamarca"
              },
              {
                "value": "44001000",
                "label": "Riohacha - La Guajira"
              },
              {
                "value": "5615000",
                "label": "Rionegro - Antioquia"
              },
              {
                "value": "68615000",
                "label": "Rionegro - Santander"
              },
              {
                "value": "8634000",
                "label": "Sabanagrande - Atlántico"
              },
              {
                "value": "5631000",
                "label": "Sabaneta - Antioquia"
              },
              {
                "value": "63690000",
                "label": "Salento - Quindío"
              },
              {
                "value": "68615001",
                "label": "San Antonio De Pereira - Antioquia"
              },
              {
                "value": "5001001",
                "label": "San Antonio De Prado - Antioquia"
              },
              {
                "value": "5656000",
                "label": "San Jeronimo - Antioquia"
              },
              {
                "value": "52001000",
                "label": "San Juan De Pasto - Nariño"
              },
              {
                "value": "23686000",
                "label": "San Pelayo - Córdoba"
              },
              {
                "value": "47001000",
                "label": "Santa Marta - Magdalena"
              },
              {
                "value": "66682000",
                "label": "Santa Rosa De Cabal - Risaralda"
              },
              {
                "value": "13683000",
                "label": "Santa Rosa De Lima - Bolívar"
              },
              {
                "value": "76736000",
                "label": "Sevilla - Valle Del Cauca"
              },
              {
                "value": "25743000",
                "label": "Silvania - Cundinamarca"
              },
              {
                "value": "25754000",
                "label": "Soacha - Cundinamarca"
              },
              {
                "value": "15759000",
                "label": "Sogamoso - Boyacá"
              },
              {
                "value": "8758000",
                "label": "Soledad - Atlántico"
              },
              {
                "value": "15764000",
                "label": "Soraca - Boyacá"
              },
              {
                "value": "15763000",
                "label": "Sotaquira - Boyacá"
              },
              {
                "value": "11769000",
                "label": "Suba - Bogotá D.C."
              },
              {
                "value": "25817000",
                "label": "Tocancipa - Cundinamarca"
              },
              {
                "value": "8832000",
                "label": "Tubara - Atlántico"
              },
              {
                "value": "76834000",
                "label": "Tulua - Valle Del Cauca"
              },
              {
                "value": "15001000",
                "label": "Tunja - Boyacá"
              },
              {
                "value": "13836000",
                "label": "Turbaco - Bolívar"
              },
              {
                "value": "13838000",
                "label": "Turbana - Bolívar"
              },
              {
                "value": "5837000",
                "label": "Turbo - Antioquia"
              },
              {
                "value": "15837000",
                "label": "Tuta - Boyacá"
              },
              {
                "value": "11850001",
                "label": "Usaquen - Bogotá D.C."
              },
              {
                "value": "20001000",
                "label": "Valledupar - Cesar"
              },
              {
                "value": "15861000",
                "label": "Ventaquemada - Boyacá"
              },
              {
                "value": "15407000",
                "label": "Villa De Leyva - Boyacá"
              },
              {
                "value": "54874000",
                "label": "Villa Del Rosario - Norte De Santander"
              },
              {
                "value": "17873000",
                "label": "Villamaria - Caldas"
              },
              {
                "value": "13873000",
                "label": "Villanueva - Bolívar"
              },
              {
                "value": "50001002",
                "label": "Villavicencio - Meta"
              },
              {
                "value": "76892000",
                "label": "Yumbo - Valle Del Cauca"
              },
              {
                "value": "25899000",
                "label": "Zipaquira - Cundinamarca"
              },
              {
                "value": "68679000",
                "label": "San Gil - Santander"
              }
            ]
          }
        )).data);
  }

  public getCiudades(sessionId: string): Observable<CiudadesModels[]> {
    let headers = new HttpHeaders({
      'Accept': '*/*',
      'SESSION_ID': sessionId,
      // 'jwt': eliminado - autenticación manejada por interceptors
    });

    return this.http.get<CiudadesModels[]>(this.baseUri, { headers: headers })
  }
}
